import { connect } from 'react-redux'
import { IDispatchProps, WebProxy } from './YumGoogleSignIn'
import { doGoogleSignIn } from './store/GoogleSignInActions'

const mapStateToProps = () => ({})

const mapDispatchToProps: IDispatchProps = {
  doGoogleSignIn,
}

export default connect(mapStateToProps, mapDispatchToProps)(WebProxy)
